/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Blog_Filter_Has_Publish_DateInputs */

const cs_blog_filter_has_publish_date = /** @type {(inputs: Blog_Filter_Has_Publish_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Datum publikace`)
};

const en_blog_filter_has_publish_date = /** @type {(inputs: Blog_Filter_Has_Publish_DateInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publication date`)
};

/**
* | output |
* | --- |
* | "Publication date" |
*
* @param {Blog_Filter_Has_Publish_DateInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const blog_filter_has_publish_date = /** @type {((inputs?: Blog_Filter_Has_Publish_DateInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Blog_Filter_Has_Publish_DateInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_blog_filter_has_publish_date(inputs)
	return cs_blog_filter_has_publish_date(inputs)
});